import React from 'react';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import {makeStyles} from '@material-ui/core/styles';
import SvgText from '../SvgText';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import {Tooltip} from "@material-ui/core";

const useStyles = makeStyles({
  root: {
    // width: '18vmin',
    // height: '24vmin',
    minHeight: 120,
    minWidth: 66,
    maxWidth: 192,
    maxHeight: 360,
  },
  actionArea: {
    height: '100%',
  },
  content: {
    padding: 8,
    wordBreak: "break-all"
  },
});

const GameCard = props => {
  const { label, emoji, className, disabled, title, ...others } = props;
  const classes = useStyles();
  return (
    <Tooltip title={title}>
      <div className={className}>
        <Card {...others} className={classes.root}>
          <CardActionArea className={classes.actionArea} disabled={disabled}>
            <div className={classes.content}>

              <div className='card-inner-svg'>
                <div className='card-inner-svg__inner'>
                  <SvgText className='card-inner-svg__inner-svg'>{emoji}</SvgText>
                </div>
                <Box textAlign="center">
                  <Typography variant="h5" fontFamily="Monospace">
                    {label}
                  </Typography>
                </Box>
              </div>

            </div>
          </CardActionArea>
        </Card>
      </div>
    </Tooltip>
  );
};

export default GameCard;
